// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"_33974c2b58--fullscreen--PrFzo"};